import { DataItem } from 'scrivito'

import { ContactProjectRelation } from '@/Data/ContactProjectRelation/ContactProjectRelationDataClass'
import { Ticket } from '@/Data/Ticket/TicketDataClass'
import { DataScopeOrder } from '@/Data/types'
import { useDataClassIndex } from '@/hooks/useDataClassIndex'
import { getDataItem } from '@/utils/getDataItem'

interface Args {
  subjectId: string
  search: string
  order: DataScopeOrder
  listSize: number
}

interface TicketRow {
  id: string
  ticket: DataItem
  relation: DataItem
}

export const useTicketTabData = ({
  subjectId,
  search,
  order,
  listSize,
}: Args) => {
  const {
    dataItems: relations,
    hasMore,
    loadMore,
    count,
  } = useDataClassIndex(
    ContactProjectRelation,
    {
      filters: {
        contact: subjectId,
        projectEntity: 'Ticket',
        project_search: search,
      },
      order: [order],
    },
    listSize,
  )

  const items: TicketRow[] = relations.flatMap((relation) => {
    const ticketId = relation.get('project') as string
    if (!ticketId) return []
    const { dataItem: ticket } = getDataItem(Ticket, ticketId)
    if (!ticket) return []
    return [{ id: ticket.id(), ticket, relation }]
  })

  return { items, hasMore, loadMore, count }
}
